import { type SearchDomainIndexName } from '~/search-domain/indexes';
import { getSearchPipelineDefinitionByIndex } from '~/search-domain/pipelineRegistry';
import { type SearchUiConfig, type SearchUiContext } from '~/search-domain/types';

export function getSearchConfig(
  indexName: SearchDomainIndexName,
  context: SearchUiContext,
): SearchUiConfig | undefined {
  const definition = getSearchPipelineDefinitionByIndex(indexName);
  if (!definition) return undefined;
  return definition.getSearchUiConfig(context);
}
